import { IonList } from '@ionic/react';
import { Player } from '@lottiefiles/react-lottie-player';
import { ReactElement } from 'react';
import i18n from '../../../i18n';
import { LoadingButton } from '../../button/loading-button';
import { IonItem } from '../../ionic/IonItem';
import { LoginConfirmProps } from '../login-confirm';
import validLink from '../lottie/valid-link.json';

const ValidLinkLogin = (props: LoginConfirmProps): ReactElement => {
  const { consumeChallengeOnClick, loading, magicLink } = props;
  return (
    <>
      <IonList lines="none">
        <IonItem>
          <p>{i18n.t('common:login_confirm_valid_link')}</p>
        </IonItem>
        <div>
          <Player
            src={validLink}
            loop={true}
            autoplay={true}
            style={{ height: '150px', width: '150px' }}
          />
        </div>
      </IonList>
      <br />
      <div className="ion-padding-horizontal">
        <LoadingButton
          className={'confirm-magic-link-button'}
          loading={loading}
          buttonProps={{
            type: 'submit',
            disabled: !magicLink.isValid(),
            expand: 'block',
            onClick: consumeChallengeOnClick,
          }}
        >
          {i18n.t('common:next')}
        </LoadingButton>
      </div>
    </>
  );
};

export { ValidLinkLogin };
